import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';
import BandMarker from '../markers/BandMarker';

/** Ultimate Oscillator indicator */
export default class UltimateOscillatorIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} bands - Indicator bands
	 */
	_getDefaultParams() {
		return {
			id: 'ultimateoscillator',
			name: 'Ultimate Oscillator',
			description:
				"The Ultimate Oscillator reduces the effect of time from the oscillator's bullish and bearish signals. This indicator is most effective when it offers a bullish or bearish divergence.",
			inputs: [
				{ name: 'period1', value: 7 },
				{ name: 'period2', value: 14 },
				{ name: 'period3', value: 28 },
				{ name: 'factor1', value: 4, max: 10 },
				{ name: 'factor2', value: 2, max: 10 },
				{ name: 'factor3', value: 1, max: 10 }
			],
			bands: [
				{
					labelTranslationKey: 'band.overbought',
					valHigh: 100,
					valLow: 70
				},
				{
					labelTranslationKey: 'band.oversold',
					valHigh: 30,
					valLow: 0
				}
			],
			componentSeries: [
				{ id: 'ultimateoscillator' }
			]
		};
	}

	/** @return {number} 0 */
	getRangeMin() {
		return 0;
	}

	/** @return {number} 100 */
	getRangeMax() {
		return 100;
	}

	/**
	 * @return {object}
	 * @property {LineMarker} line
	 * @property {BandMarker} overbought
	 * @property {BandMarker} oversold
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			overbought: new BandMarker(this.params.bands[0], this.panel),
			oversold: new BandMarker(this.params.bands[1], this.panel)
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this.markers.overbought.render(this.panel, this.params.style.overbought);
		this.markers.oversold.render(this.panel, this.params.style.oversold);
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
